import { Dispatch, SetStateAction } from "react";
import {getUser} from "@/common/utils.ts";
import {
  dcpAppUserList,
  dcpAppUserAllList,
} from '@/services/kuAccount'
import {getDictByParentKey} from "@/services/talkOrder.ts";
import {apiData2Table} from "@/utils/data.ts";

/**
 * 表格统一请求
 * @param values - 表单数据
 * @returns 
 */
 export const fetchList = (values: any) => {
  return new Promise((resolve, reject) => {
    try {
      const { current, pageSize, query } = values;
      dcpAppUserList(current, pageSize, query).then(data => resolve(apiData2Table(data)))
    } catch {
      reject({ success: false });
    }
  });
};

/**
 * 获取当前用户账号
 * @param setCurUseAccount 
 */
 export const getAccountState = async (setCurUseAccount: Dispatch<SetStateAction<any>>) => {
  const userData = getUser() || {};
  try {
    const userList: any = await dcpAppUserAllList({
      lastUser: userData?.ucenterUserId,
    })
    setCurUseAccount( userList.length > 0? userList[0]:{});
  } catch (error) {
  }
}

/**
 * 获取岗位权限
 * @param setAuthData 
 */
 export const getPostAuth = async (setAuthData: Dispatch<SetStateAction<any>>) => {
  try {
    const authData: any = await getDictByParentKey({ priKey: 'ForcedRestitution' })
    let list  = []
    authData?.map(item => {
      const arr = item?.dataValue ? item?.dataValue.split(',') : []
      list = list.concat(arr)
    })
    setAuthData([...new Set(list)]);
  } catch (error) {
  }
}

